import { render, staticRenderFns } from "./scarecrow-wines.vue?vue&type=template&id=0179f5e6&scoped=true"
import script from "./scarecrow-wines.vue?vue&type=script&lang=js"
export * from "./scarecrow-wines.vue?vue&type=script&lang=js"
import style0 from "./scarecrow-wines.vue?vue&type=style&index=0&id=0179f5e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0179f5e6",
  null
  
)

export default component.exports